import {SearchableRow} from "./types";

export const PAGINATION_BUTTON_LIMIT = 7
export const PAGINATION_LIMIT_DEFAULT = 25
export const PAGINATION_LIMIT_OPTIONS = [5, 10, 25, 50, 100]

export function calculatePageCount<T>(rows: SearchableRow<T>[], paginationLimit: number): number {
  return Math.ceil(rows.length / paginationLimit)
}

export function getPagination(page: number, pageCount: number, paginationLimit: number): number[] {
  const pages = []
  for (let i = 0; i < pageCount; i++) {
    pages.push(i)
  }
  if (pageCount <= (PAGINATION_BUTTON_LIMIT*2+1)) {
    return pages
  }
  const subSelection = pages.slice(Math.max(0, page - PAGINATION_BUTTON_LIMIT), Math.min(pageCount, page + PAGINATION_BUTTON_LIMIT + 1))
  if (subSelection[0] > 1) {
    subSelection.unshift(0)
  }
  if (subSelection[subSelection.length - 1] < pageCount - 2) {
    subSelection.push(pageCount - 1)
  }
  return subSelection
}

export function paginateRows<T>(rows: T[], page: number, paginateSize: number): T[] {
  if (rows.length < paginateSize) {
    return rows
  }
  return rows.slice((page)*paginateSize, (page)*paginateSize + paginateSize)
}